module.exports = __webpack_public_path__ + "static/media/love.0d74ccf3.mp3";